import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Select,
    Input,
} from 'antd';
const FormItem = Form.Item;
import { actions, asyncGet, deleteAll } from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
const spans = {
    xs: 14,
    sm: 14,
    md: 6,
    lg: 6,
    xl: 6,
};

class Search extends React.Component {
    constructor(props) {
        super(props);
    }

    handleReset= () => {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch = () => {
        let values = this.props.form.getFieldsValue();
        for (let i in values) {
            if (values[i] == -1 || values[i] === '' || values[i] === undefined) {
                delete values[i];
            }
        }
        console.log('=====searchValue', values);
        this.props.changeSearchValues(values);
        this.props.resetPagination();
        this.props.asyncGet();
    }
    deleteAll = () => {
        // 批量删除
        this.props.deleteAll()
            .then(() => {
                this.props.asyncGet();
            });
    }
    add = () => {
        this.props.editShow();
    }
    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>客户端组列表</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={6}>
                            <FormItem {...spans} label="分组ID">
                                {getFieldDecorator('groupId')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem {...spans} label="分组名称">
                                {getFieldDecorator('note')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem {...spans} label="客户端ID">
                                {getFieldDecorator('clientId')(<Input placeholder="请填写" style={{ width: '100%' }} />)}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="分组类型" {...spans}>
                                {getFieldDecorator('groupType')(
                                    <Select allowClear placeholder="全部" style={{ width: 160 }}>
                                        <Option key='0' value='-1'>
                                            全部
                                        </Option>
                                        <Option key='1' value='ANDROID'>
                                            ANDROID
                                        </Option>
                                        <Option key='2' value='LINUX'>
                                            LINUX
                                        </Option>
                                        <Option key='3' value='IOS'>
                                            IOS
                                        </Option>
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                            <Button type="danger" onClick={this.deleteAll} style={{ margin: '0 8px' }}>
                                批量删除
                            </Button>
                            <Button style={{ margin: '0 8px' }} onClick={this.add}>
                                添加分组
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => ({
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    resetPagination: () => dispatch(actions.changePagination({ current: 1 })),
    asyncGet: () => dispatch(asyncGet()),
    deleteAll: () => dispatch(deleteAll()),
    editShow: () => dispatch(actions.changeUiStatus({ isUpdateShow: true })),
});

export default connect(null, mapDispatchToProps)(Form.create()(Search));



// WEBPACK FOOTER //
// ./pages/assist/clientManage/search.js